import { motion, AnimatePresence } from "framer-motion";

const fadeInUpVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
  exit: { opacity: 0, y: -30, transition: { duration: 0.4, ease: "easeIn" } },
};

const WorkPage = ({ goToPage, isActive }) => {
  return (
    <div className="page intro-page">
      <div className="grid-background"></div>
      <AnimatePresence>
        {isActive && (
          <motion.div
            className="intro-content"
            key="intro-content"
            variants={fadeInUpVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <h2>HELLO.</h2>
            <p>
              Nice to meet you! I'm Lavanya, a software engineer based in
              Germany. I love to solve problems and create innovative solutions
              that make a difference.
            </p>
            <p>
              Oh, and I am also a hobbyist photographer, capturing moments that
              tell stories and evoke emotions :)
            </p>
            <a
              href="https://www.instagram.com/lava.clicks2104/"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button"
            >
              Checkout my photography page on IG
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default WorkPage;
